import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';

import { pages } from '@shared/config/pages';
import { AccessOptions } from '@shared/models/accessOptions.model';
import { Personas } from '@shared/models/personas.model';
import { UserService } from '@shared/services/user.service';
import { AuthenticationService } from './authentication.service';
import { NavigationService } from './navigation.service';

@Injectable({
  providedIn: 'root',
})
export class HomeRedirectGuard implements CanActivate {
  constructor(
    private userService: UserService,
    private navigationService: NavigationService,
    private authenticationService: AuthenticationService
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const isAuthenticated = this.authenticationService.isAuthenticated();
    if (isAuthenticated) {
      const accessOptions = (this.userService.getCurrentUser().persona as Personas).accessOptions as AccessOptions[];
      const homeAccessOptions = accessOptions.find((accessOption: AccessOptions) => accessOption.isHome);
      const accessOptionsOfPage = this.userService.getAccessOptionsOfPage(state.url);

      if (homeAccessOptions && homeAccessOptions.pageUrl && !accessOptionsOfPage?.isHome) {
        this.navigationService.navigateTo(homeAccessOptions.pageUrl);
        return false;
      } else {
        this.navigationService.navigateTo('access-denied');
        return false;
      }
    } else {
      this.navigationService.navigateByUrl(pages.login).catch();
      return false;
    }
  }
}
